export function isField(value: string): boolean {
    return value?.startsWith('[') && value.endsWith(']');
}
